import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UtilityService {

  constructor() { }

  isNull(value: any): boolean {
    return ( value === undefined || value === null)
  }

  isNullOrEmpty(value: any): boolean {
    return this.isNull(value) ? true : value.toString().length == 0;
  }

  addHypensToPhoneNumber(phone: string| number): string {
    if (this.isNullOrEmpty(phone))
      return phone?.toString();

    let originalPhone = phone.toString();
    return originalPhone.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
  }

}
